import React from "react";
import {
  Layout,
  Typography,
  Button,
  Space,
  Grid,
  Row,
  Col,
  Card,
} from "antd";
import {
  CheckCircleOutlined,
  DollarOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";

import MainHeader from "../components/layout/MainHeader";
import MainFooter from "../components/layout/MainFooter";
import "./BanhoDeOuroSemijoias.css";
import PorqueEscolher from "../components/components/porque_escolher/banho_ouro/porqueescolher";
import ComoFunciona from "../components/components/como_funciona/comoFunciona";
import ProofResultsSection from "../components/components/prova_social/ProofResultsSection";
import WhoWeServeSection from "../components/pra_quem-serve/WhoWeServeSection";
import FAQSection from "../components/components/FAQ/FAQSection.js";
import FloatingCTA from "../components/components/common/FloatingCTA.js";

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;

function VernizCataforetico() {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  return (
    <Layout>
      <MainHeader />
      <FloatingCTA triggerId="trigger-floating-cta" />

      <Content>
        <section className="section-banho-ouro">
          <div
            style={{
              maxWidth: 1400,
              margin: "0 auto",
              padding: isMobile ? "32px 16px 0" : "48px 20px 0",
            }}
          >
            <div
              style={{
                maxWidth: 980,
                margin: "0 auto",
                textAlign: "center",
                paddingBottom: isMobile ? 32 : 48,
              }}
            >
              <Title
                style={{
                  color: "#fff",
                  fontSize: "clamp(2.2rem, 5vw, 4.8rem)",
                  lineHeight: 1.05,
                  marginBottom: 20,
                }}
              >
                <span className="p-titulo">Verniz Cataforético</span> para
                Semijoias e Bijuterias com proteção{" "}
                <span className="p-titulo">premium</span>
              </Title>

              <Paragraph
                style={{
                  color: "#ffffffd9",
                  fontSize: isMobile ? 16 : 18,
                  lineHeight: 1.7,
                  maxWidth: 760,
                  margin: "0 auto 28px",
                }}
              >
                Um acabamento técnico pensado para proteger a peça, aumentar a
                durabilidade e elevar a percepção de qualidade da sua produção.
              </Paragraph>

              <Space
                wrap
                style={{
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <Button
                  className="btn-ouro"
                  size="large"
                  onClick={() => {
                    window.dataLayer = window.dataLayer || [];

                    window.dataLayer.push({
                      event: "leads",
                      lead_source: "botao_solicitar_orcamento",
                      page_path: window.location.pathname,
                    });

                    window.open(
                      "https://wa.me/5511996064416?text=Olá!%20Quero%20saber%20mais%20sobre%20o%20Verniz%20Cataforético.",
                      "_blank"
                    );
                  }}
                  style={{
                    width: isMobile ? "100%" : "auto",
                    maxWidth: isMobile ? 320 : "none",
                  }}
                >
                  Solicitar orçamento
                </Button>
                {/* <Button
                  className="btn-ouro"
                  size="large"
                  href="https://wa.me/5511996064416?text=Olá!%20Quero%20saber%20mais%20sobre%20o%20Verniz%20Cataforético."
                  target="_blank"
                  style={{
                    width: isMobile ? "100%" : "auto",
                    maxWidth: isMobile ? 320 : "none",
                  }}
                >
                  Solicitar orçamento
                </Button> */}
              </Space>
            </div>

            {/* VIDEO */}
            <div
              style={{
                width: "100%",
                borderTopLeftRadius: 24,
                borderTopRightRadius: 24,
                overflow: "hidden",
                background: "#1a1a1a",
                boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
              }}
            >
              <video
                src="/videos/catafo.mp4"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                controls={false}
                poster="/images/capa-video.jpg"
                style={{
                  width: "100%",
                  height: "clamp(280px, 52vw, 720px)",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </div>
          </div>
        </section>

        <section
          style={{
            background: "#ffffff",
            padding: isMobile ? "56px 16px" : "80px 20px",
          }}
        >
          <div style={{ maxWidth: 1200, margin: "0 auto" }}>
            <div
              style={{
                maxWidth: 900,
                margin: "0 auto 48px",
                textAlign: "center",
              }}
            >
              <Title
                level={2}
                style={{
                  marginBottom: 20,
                  fontSize: "clamp(1.8rem, 3vw, 2.8rem)",
                }}
              >
                O que muda com o verniz na sua joia?
              </Title>

              <Paragraph
                style={{
                  fontSize: isMobile ? 16 : 18,
                  lineHeight: 1.8,
                  color: "#555",
                  marginBottom: 0,
                }}
              >
                O verniz cataforético funciona como uma camada de proteção sobre
                a peça, ajudando a preservar o brilho, reduzir o desgaste
                natural do uso e entregar um acabamento final mais valorizado.
                Na prática, ele aumenta a resistência da joia e melhora a
                experiência de quem compra, porque a peça mantém aparência
                bonita por mais tempo.
              </Paragraph>
            </div>

            <Row gutter={[24, 24]} style={{ marginBottom: 48 }}>
              <Col xs={24} md={8}>
                <Card
                  style={{
                    height: "100%",
                    borderRadius: 20,
                    border: "1px solid #ececec",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                  }}
                >
                  <div
                    style={{
                      width: 58,
                      height: 58,
                      borderRadius: "50%",
                      background: "rgba(212, 180, 131, 0.12)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#d4b483",
                      fontSize: 24,
                      marginBottom: 18,
                    }}
                  >
                    <SafetyCertificateOutlined />
                  </div>

                  <Title level={4}>Mais proteção</Title>

                  <Paragraph style={{ color: "#555", marginBottom: 0 }}>
                    Ajuda a proteger a superfície da peça contra desgaste,
                    oxidação e perda precoce de aparência.
                  </Paragraph>
                </Card>
              </Col>

              <Col xs={24} md={8}>
                <Card
                  style={{
                    height: "100%",
                    borderRadius: 20,
                    border: "1px solid #ececec",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                  }}
                >
                  <div
                    style={{
                      width: 58,
                      height: 58,
                      borderRadius: "50%",
                      background: "rgba(212, 180, 131, 0.12)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#d4b483",
                      fontSize: 24,
                      marginBottom: 18,
                    }}
                  >
                    <CheckCircleOutlined />
                  </div>

                  <Title level={4}>Mais valor percebido</Title>

                  <Paragraph style={{ color: "#555", marginBottom: 0 }}>
                    A peça chega com acabamento mais refinado, transmitindo mais
                    qualidade para o cliente final e fortalecendo sua marca.
                  </Paragraph>
                </Card>
              </Col>

              <Col xs={24} md={8}>
                <Card
                  style={{
                    height: "100%",
                    borderRadius: 20,
                    border: "1px solid #ececec",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                  }}
                >
                  <div
                    style={{
                      width: 58,
                      height: 58,
                      borderRadius: "50%",
                      background: "rgba(212, 180, 131, 0.12)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#d4b483",
                      fontSize: 24,
                      marginBottom: 18,
                    }}
                  >
                    <DollarOutlined />
                  </div>

                  <Title level={4}>Mais economia</Title>

                  <Paragraph style={{ color: "#555", marginBottom: 0 }}>
                    Reduz retrabalho, diminui risco de reclamações e ajuda sua
                    operação a evitar perdas com peças que se desgastam rápido.
                  </Paragraph>
                </Card>
              </Col>
            </Row>
          </div>
        </section>

        {/* <PorqueEscolher />
        <section id="trigger-floating-cta">
          <ComoFunciona />
        </section>
        <ProofResultsSection />
        <WhoWeServeSection />
        <FAQSection /> */}
      </Content>

      <MainFooter />
    </Layout>
  );
}

export default VernizCataforetico;